import { AppLayout } from "layout";
import { EduContentCourseData } from "../components";

type Props = {};

const EduContentCourseContainer = (props: Props) => {

    return (
        <AppLayout>
            <EduContentCourseData />
        </AppLayout>
    );
};

export default EduContentCourseContainer;
